import { useEffect, useState } from "react";

function Footer() {
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        setYear(new Date().getFullYear());
    }, []);
    return (
        <>
            <div>
                <footer className="main-footer">
                    <strong>Copyright ©{year} <a href="https://pitangent.com/">Pitangent</a> </strong>
                    All rights reserved.
                    <div className="float-right d-none d-sm-inline-block">
                        <b>Version</b> 1.0.0
                    </div>
                </footer>
                <aside className="control-sidebar control-sidebar-dark">
                </aside>
            </div>

        </>
    )
}

export default Footer
